.label-and-grouping-selector {
  justify-content: space-between;
  align-items: center;
}
